<template>
    <section>
         <div style='width:100%; height:80px; background:#DCDBDD; '>
            <h1 style='margin-left:20px; padding-top:20px'><slot> </slot> </h1>
         </div>    
        
    </section>
</template> 